import { PatientNote, PatientNoteCreateCommand, PatientSimple } from '@dreryk/egabinet-patient-frontend-api';

import { useCqrsCommand, UseCqrsCommandResult } from '@dreryk/command-query-react-common';
import { Choice } from '@dreryk/watermelon';

import { NoteFormBean } from '../NoteModalCommon/NoteModalCommon';

type PatientNoteCreateParameters = NoteFormBean & { patientId: PatientSimple['id'] };

export const usePatientNoteCreateCommand = (
   onSuccess: () => void
): UseCqrsCommandResult<PatientNote, PatientNoteCreateParameters> => {
   return useCqrsCommand<PatientNote, PatientNoteCreateParameters>(
      (parameters) => {
         const command = new PatientNoteCreateCommand();
         command.patientId = parameters.patientId!;
         command.content = Choice.withUseDefaultIfNull(parameters.content);
         return command;
      },
      {
         onSuccess: onSuccess,
      }
   );
};
